import { render, staticRenderFns } from "./mgmtRole.vue?vue&type=template&id=50429223&scoped=true"
import script from "./mgmtRole.vue?vue&type=script&lang=js"
export * from "./mgmtRole.vue?vue&type=script&lang=js"
import style0 from "./mgmtRole.vue?vue&type=style&index=0&id=50429223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50429223",
  null
  
)

export default component.exports